/**
 * Base store — the one state-sharing primitive in core.
 *
 * Platform bindings stay thin because they all consume the same shape:
 *   web (Lit):  subscribe(() => this.host.requestUpdate())
 *   RN (React): useSyncExternalStore(store.subscribe, store.getSnapshot)
 *
 * Snapshots must be immutable values — stores rebuild them on change so
 * reference equality is a valid dirty check. `getSnapshot`/`subscribe` are
 * closures, so they stay bound when bindings pass them unbound (React:
 * `useSyncExternalStore(store.subscribe, store.getSnapshot)`).
 */
export function createStore(build) {
    const listeners = new Set();
    let snapshot = build();
    return {
        getSnapshot: () => snapshot,
        subscribe(listener) {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
            };
        },
        commit() {
            snapshot = build();
            listeners.forEach((listener) => listener(snapshot));
        },
        dispose() {
            listeners.clear();
        },
    };
}
